import store from '@/store';

export default [
  {
    name: "AgentConsole",
    path: "/agent-console",
    component: () => import('../../views/AgentConsole.vue'),
    meta: {
      requiresAuth: true,
      access_control: ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_MANAGER', 'ROLE_AGENT_BASIC'],
      icon: "fas fa-headset",
      type: "link",
      isInMenu: true,
      title: 'main-menu.agent-console.title',
      order: 6,
      custom_access_control: (user, agent) => {
        const { number = 0 } = agent;
        return number > 0;
      }
    },
    beforeEnter: (to, from, next) => {
      const { number = 0 } = store.getters.getAgent;
      if (number === 0) {
        return next({ name: 'Home' });
      }
      return next();
    },
    children: [
      {
        name: "AgentDashboard",
        path: "dashboard",
        meta: {
          access_control: ['ROLE_AGENT', 'ROLE_AGENT_BASIC']
        },
        components: {
          agentConsoleTools: () => import('../../views/AgentDashboard.vue')
        }
      },
      {
        name: "CallClasification",
        path: "call-clasification",
        meta: {
          access_control: ['ROLE_AGENT', 'ROLE_AGENT_BASIC']
        },
        components: {
          agentConsoleTools: () => import('../../views/agent-console/TheCallDisposition.vue')
        }
      },
      {
        name: "CallTranscription",
        path: "call-transcription",
        meta: {
          access_control: ['ROLE_AGENT', 'ROLE_AGENT_BASIC']
        },
        components: {
          agentConsoleTools: () => import('../../views/agent-console/TheTranscriptionBox.vue')
        }
      },
      {
        name: "AddNewCustomer",
        path: "new-customer",
        meta: {
          access_control: ['ROLE_AGENT', 'ROLE_AGENT_BASIC']
        },
        components: {
          agentConsoleTools: () => import('../../views/agent-console/TheNewCustomer.vue')
        }
      },
      // {
      //   name: "SearchCustomer",
      //   path: "search-customer",
      //   components: {
      //     agentConsoleTools: () => import('../../views/agent-console/TheSearchCustomer.vue')
      //   }
      // }
    ]
  }
];
